<template>
  <path pid="0" d="M11.39 5.21l-9 7a1 1 0 000 1.58l9 7A1 1 0 0013 20V6a1 1 0 00-1.61-.79zM11 18l-6.37-5L11 8z"/><path pid="1" d="M22.39 5.21l-9 7a1 1 0 000 1.58l9 7A1 1 0 0024 20V6a1 1 0 00-1.61-.79zM22 18l-6.37-5L22 8z"/>
</template>
